export const heroStats = [
  { value: '4 类', label: '入口分类', icon: 'ri-layout-grid-line' },
  { value: '34 条', label: '地址与说明记录', icon: 'ri-bookmark-3-line' },
  { value: '定期', label: '入口信息核对', icon: 'ri-refresh-line' },
  { value: '全端', label: '桌面 · 移动 · 平板', icon: 'ri-device-line' },
];

export const heroPoints = [
  {
    icon: 'ri-compass-3-line',
    title: '先看入口总览',
    desc: '先判断自己需要哪一种入口：首页、最新地址还是永久发布页。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '再核对更新记录',
    desc: '通过时间线确认当前地址信息是否已经过期或被替换。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '最后学辨别方法',
    desc: '掌握核对官方标识的方法，避免进入仿冒或误导页面。',
  },
];

export const entryChannels = [
  {
    icon: 'ri-home-4-line',
    tag: '主推荐',
    name: '官方首页入口',
    summary: '进入站内主导航的第一站',
    desc: '通过首页入口可以直达站内主导航，首页顶部通常集中展示公告、入口更新与片单分类。第一次访问的用户建议从首页入口开始，先确认页面整体结构，再去查找具体内容。',
    points: ['适合首次访问', '集中展示公告与更新', '跳转分类更直接'],
  },
  {
    icon: 'ri-link-m',
    tag: '需核对',
    name: '最新地址通道',
    summary: '当常用地址无法打开时使用',
    desc: '入口地址会因网络调整而变动，最新地址会与公告同步更新。使用前请对照更新记录中的日期与变更说明，确认该地址是否为当前记录在册的版本，避免使用过期入口。',
    points: ['对照更新时间', '留意变更说明', '过期入口应更换'],
  },
  {
    icon: 'ri-layout-masonry-line',
    tag: '分类清晰',
    name: '网址大全导航',
    summary: '按终端与场景整理入口',
    desc: '网址大全把不同类型入口集中归类，涵盖桌面端、移动端、备用通道与帮助说明。用户可以根据自己的设备与网络环境筛选合适的入口，而不必在多个零散页之间来回切换。',
    points: ['按终端分类', '按场景筛选', '一页集中查看'],
  },
  {
    icon: 'ri-anchor-line',
    tag: '长期有效',
    name: '永久入口发布页',
    summary: '不受单次变动影响的固定入口',
    desc: '发布页用于长期记录入口信息，不会随着某一次地址调整而失效，因此更适合收藏。建议把发布页作为查找所有入口的起点，再根据发布页中的记录判断当前可用的访问方式。',
    points: ['建议长期收藏', '作为查找起点', '记录更完整'],
  },
];

export const updateLog = [
  {
    date: '2026-10-06',
    tag: '例行核对',
    title: '入口信息完成本轮核对',
    desc: '对首页入口、网址大全分类与永久发布页信息进行了整轮核对，更新了部分说明文字，未发现需要替换的分类结构。',
  },
  {
    date: '2026-09-22',
    tag: '结构调整',
    title: '移动端入口说明细化',
    desc: '补充了移动端与平板端的区分说明，帮助用户根据屏幕尺寸选择更合适的浏览方式，减少误入不匹配终端入口的情况。',
  },
  {
    date: '2026-09-08',
    tag: '内容更新',
    title: '网址大全分类重新整理',
    desc: '把原本混在一起的入口按“首页、移动端、备用通道、发布页、帮助说明”重新归类，筛选与查找都更直接。',
  },
  {
    date: '2026-08-25',
    tag: '说明补充',
    title: '备用通道使用说明上线',
    desc: '新增备用通道的适用场景与注意事项说明，明确备用通道与主入口在使用顺序上的区别，便于用户按需选择。',
  },
  {
    date: '2026-08-11',
    tag: '改版',
    title: '首页公告区排版调整',
    desc: '将公告与入口更新调整到首页更靠前的位置，减少用户翻找成本，让入口变化能被更快看到。',
  },
];

export const directoryCategories = ['全部', '首页入口', '移动端', '备用通道', '发布页', '帮助说明'];

export const directoryItems = [
  {
    category: '首页入口',
    name: '综合首页入口',
    desc: '站内主导航的总入口，公告、分类与更新记录都从这里展开，适合作为首次访问的起点。',
    meta: '桌面与移动均适用',
    icon: 'ri-home-smile-line',
  },
  {
    category: '首页入口',
    name: '桌面端访问通道',
    desc: '针对较宽屏幕优化的入口，信息展示更完整，适合需要同时查看多个分类的用户。',
    meta: '推荐 1024px 以上屏幕',
    icon: 'ri-computer-line',
  },
  {
    category: '移动端',
    name: '手机端适配入口',
    desc: '为窄屏优化的入口，按钮与列表更贴合手指操作，适合通勤等碎片时间浏览。',
    meta: '推荐手机使用',
    icon: 'ri-smartphone-line',
  },
  {
    category: '移动端',
    name: '平板浏览入口',
    desc: '兼顾触控与横向空间的入口，横屏时可获得接近桌面端的浏览体验。',
    meta: '推荐平板使用',
    icon: 'ri-tablet-line',
  },
  {
    category: '备用通道',
    name: '备用访问通道',
    desc: '当主入口因网络波动暂时无法打开时使用；建议先确认主入口确实不可用再切换。',
    meta: '主入口异常时使用',
    icon: 'ri-route-line',
  },
  {
    category: '备用通道',
    name: '备用通道说明页',
    desc: '解释备用通道与主入口的区别、适用场景与切换建议，帮助用户判断何时该用备用方式。',
    meta: '切换前阅读',
    icon: 'ri-information-line',
  },
  {
    category: '发布页',
    name: '永久发布页',
    desc: '长期记录入口信息的固定页面，不因单次地址变动而失效，是最适合收藏的一类入口。',
    meta: '建议长期收藏',
    icon: 'ri-anchor-line',
  },
  {
    category: '发布页',
    name: '入口变更公告',
    desc: '集中说明每次入口调整的原因、时间与影响范围，便于用户对照时间线了解情况。',
    meta: '与更新记录同步',
    icon: 'ri-megaphone-line',
  },
  {
    category: '帮助说明',
    name: '入口找回指南',
    desc: '当所有常用入口都无法访问时，按步骤排查网络、缓存与设备问题，再回到发布页确认记录。',
    meta: '异常时查阅',
    icon: 'ri-question-line',
  },
  {
    category: '帮助说明',
    name: '安全浏览提示',
    desc: '说明如何识别仿冒页面、如何保护账号与个人隐私，减少因误信不明入口带来的风险。',
    meta: '建议定期阅读',
    icon: 'ri-shield-star-line',
  },
];

export const accessSteps = [
  {
    step: '01',
    title: '确认设备与网络',
    desc: '先明确自己使用的是电脑、手机还是平板，并确认当前网络连接稳定，再决定选择哪一类入口。',
  },
  {
    step: '02',
    title: '从官方入口进入',
    desc: '优先使用官方首页入口或永久发布页，不要随意点击来路不明的短链与二维码跳转。',
  },
  {
    step: '03',
    title: '核对页面标识',
    desc: '进入后先看页面名称、公告与版权信息是否一致，出现明显不一致时应立即退出并回到发布页。',
  },
  {
    step: '04',
    title: '收藏并记录',
    desc: '确认无误后把发布页加入收藏，并记录本次访问的日期，方便下次对照更新记录判断是否变更。',
  },
  {
    step: '05',
    title: '异常时按序处理',
    desc: '若无法打开，先刷新与清缓存，不行再切换到备用通道，仍无法访问则回到发布页查看最新说明。',
  },
];

export const verifyItems = [
  { id: 'v1', label: '页面名称与公告内容前后一致，没有相互矛盾的说法' },
  { id: 'v2', label: '页面不使用夸张的限时诱导文字要求立即输入账号' },
  { id: 'v3', label: '入口来源可追溯，来自发布页或站内公告，而非陌生人转发' },
  { id: 'v4', label: '页面整洁规范，没有大量弹窗、遮挡式广告或强制跳转' },
  { id: 'v5', label: '不会索取与浏览无关的敏感信息，如支付密码、验证码' },
  { id: 'v6', label: '出现异常时能回到发布页对照记录，而不是被反复重定向' },
];

export const permanentMethods = [
  {
    icon: 'ri-bookmark-3-line',
    title: '浏览器收藏发布页',
    desc: '把永久发布页加入浏览器书签，并在书签中写清收藏日期，便于日后对照更新记录判断信息是否过期。',
    label: '推荐做法',
  },
  {
    icon: 'ri-file-list-2-line',
    title: '本地记录入口信息',
    desc: '用便签或文档记录入口分类与最近一次核对时间，避免只依赖记忆，也能在更换设备时快速找回。',
    label: '备用做法',
  },
  {
    icon: 'ri-mail-send-line',
    title: '关注公告与更新',
    desc: '定期查看首页公告与更新记录，入口一旦调整会在这里同步说明，是判断最新状态的主要依据。',
    label: '定期查看',
  },
  {
    icon: 'ri-history-line',
    title: '对照历史变更',
    desc: '当同一入口名称多次出现时，以时间线上更靠后的记录为准，避免使用已被替换的旧版本说明。',
    label: '判断依据',
  },
];

export const safetyTips = [
  {
    icon: 'ri-shield-check-line',
    title: '只从记录在册的入口进入',
    desc: '不要点击聊天群、评论或弹窗中临时出现的链接，优先使用发布页与站内公告给出的入口。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '谨慎对待账号信息',
    desc: '任何要求输入支付密码、短信验证码的页面都应立即关闭，正常浏览不需要提供这类敏感信息。',
  },
  {
    icon: 'ri-advertisement-line',
    title: '警惕夸张弹窗广告',
    desc: '大量遮挡式弹窗、夸大宣传的浮层广告往往是仿冒页面的特征，遇到时建议直接退出。',
  },
  {
    icon: 'ri-error-warning-line',
    title: '识别仿冒页面',
    desc: '仿冒页面常模仿正式页面的名称与排版，但公告、分类与版权信息往往残缺或前后矛盾。',
  },
  {
    icon: 'ri-user-shared-line',
    title: '不转发不明入口',
    desc: '来路不明的入口链接不要随手转发，既可能误导他人，也会让错误地址扩散得更快。',
  },
  {
    icon: 'ri-refresh-line',
    title: '定期核对更新',
    desc: '每隔一段时间对照更新记录核对一次当前入口，发现变化及时替换，降低使用过期入口的概率。',
  },
];

export const faqs = [
  {
    q: '星辰影院的官网入口和最新地址有什么区别？',
    a: '官网入口指的是进入站内主导航的标准通道，用于浏览公告、分类与内容；最新地址则强调“时效性”，当入口因网络调整发生变动时，最新地址会与公告同步更新。简单说，入口是固定概念，地址是需要对照日期核对的动态信息。',
  },
  {
    q: '为什么有时常用入口打不开？',
    a: '常见原因包括网络波动、浏览器缓存过期、设备与入口类型不匹配等。建议先刷新并清理缓存，再确认所用入口是否与设备匹配，仍然不行时切换到备用通道，并回到永久发布页查看是否有最新说明。',
  },
  {
    q: '网址大全里为什么要把入口分成这么多类？',
    a: '因为不同设备和场景适合的入口并不相同。桌面端适合信息量大的浏览，移动端更强调触控与轻量加载，备用通道用于主入口异常时切换，发布页则负责长期记录。分类之后用户能更快找到匹配自己情况的那一种。',
  },
  {
    q: '永久入口为什么更值得收藏？',
    a: '永久入口（发布页）不会因为某一次地址调整而失效，它持续记录入口信息，是查找所有入口的起点。收藏发布页之后，即使其它入口发生变化，也能从发布页重新找到当前有效的方式。',
  },
  {
    q: '怎样判断一个入口是不是官方入口？',
    a: '可以对照页面名称与公告是否一致、是否存在夸张诱导文字、来源是否可追溯、页面是否整洁规范等几点来核实。本页的“辨别官方网址”清单提供了逐项核对的步骤，建议照单检查后再使用。',
  },
  {
    q: '入口信息一般多久更新一次？',
    a: '入口信息采用定期核对的方式维护，遇到网络环境调整时会及时补充说明。具体时间以“最新地址更新记录”中的时间线为准，建议用户自己也记录最近一次访问日期，方便对照。',
  },
  {
    q: '发现入口异常或疑似仿冒该怎么处理？',
    a: '先停止输入任何账号信息并退出页面，回到永久发布页对照更新记录，确认官方入口；若确认遇到仿冒页面，不要转发该地址，并通过公告中给出的正规渠道说明情况。',
  },
];